import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const ProductsContractsSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )

  const itemTableClasses = classnames(styles.skeleton)
  const itemsClasses = classnames(styles.itemsClasses)
  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  return (
    <Fragment>
      <div className={mainSectionClasses}>
        <table className={styles.table}>
          <thead className={styles.tableHeader}>
            <tr>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
            </tr>
          </thead>

          <tbody className={styles.tableBody}>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default ProductsContractsSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ProductsContractsSkeleton/index.js